import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FileErrorMessages } from 'app/components/merchant/partners-portal/enums/file-error-messages.enum';
import {
  BYTES,
  DECIMAL,
  FIVE_MEGABYTES,
  FRACTION_DIGITS,
  PDF_TYPE,
  VALID_FILE_TYPES,
} from 'app/components/merchant/partners-portal/validators/file-upload.validator';
import { CommerceService } from 'app/services/commerce.service';

@Component({
  selector: 'add-availed-product-payment-terms',
  standalone: false,
  templateUrl: './add-availed-product-payment-terms.component.html',
  styleUrl: './add-availed-product-payment-terms.component.scss'
})
export class AddAvailedProductPaymentTermsComponent implements OnInit {

  @Output() public paymentTermsNotValid = new EventEmitter<boolean>();

  constructor(
    private commerceService: CommerceService
  ){}

  public frequency: any[] = [
    {name: 'Daily', disabled: false, value: 1},
    {name: 'Weekly', disabled: true, value: 2},
    {name: 'Every 15 Days', disabled: true, value: 3},
    {name: 'Monthly', disabled: true, value: 4}
  ];
  public selectedFrequency: any;
  public paymentPeriod: any[] = [
    {name: '1 Month', value: 1},
    {name: '3 Months', value: 3},
    {name: '6 Months', value: 6},
    {name: '12 Months', value: 12},
    {name: '24 Months', value: 24},
    {name: '36 Months', value: 36}
  ];
  public selectedPeriod: any;
  public driverConsent: boolean = true;

  public pdfUrl: string[] = [];
  public files: File[] = [];
  fileErrorMessage: any[] = [];
  uploadInProgress: boolean = false;

  ngOnInit(): void {
    if(this.commerceService.paymentTermsModel ){
      this.paymentTermsModel = this.commerceService.paymentTermsModel;
    }
  }

  public paymentTermsModel: any = {
    selectedFrequency: {},
    selectedPeriod: {},
    driverConsent: true,
    pdfUrl: [],
    files: []
  };

  public handlePdfChange(event: any) {
    this.uploadInProgress = true;
    const fileList = event.target ? event.target.files : event as HTMLInputElement;

    if (fileList) {
      this.paymentTermsModel.files = Array.from(fileList);
    }

    if (!this.paymentTermsModel.files) {
        return;
    }

    if(this.paymentTermsModel.files.length > 3){
      this.fileErrorMessage = [{
        severity: 'error', detail: 'You can upload up to 3 pdf of the agreement.'}];
      this.paymentTermsModel.pdfUrl = [];
      this.paymentTermsModel.files = [];

      return;
    }

    for(const file of this.paymentTermsModel.files){
      const fileIsValid = this.fileValidator(file as File);

      if (!fileIsValid) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        if (e?.target?.result) {
            // Base64 string
            this.paymentTermsModel.pdfUrl.push(e.target.result.toString());
            this.commerceService.paymentTermsModel = this.paymentTermsModel;
            this.paymentTermsNotValid.emit(this.paymentTermsModel.pdfUrl.length === 0
              || !this.paymentTermsModel.selectedFrequency
              || !this.paymentTermsModel.selectedPeriod
              || this.paymentTermsModel.driverConsent === undefined);
        }
      };

      reader.readAsDataURL(file);
    }

    this.uploadInProgress = false;
  }

  fileValidator(file: File): boolean {
    const filesize = parseInt(
      (file.size / BYTES / BYTES).toFixed(FRACTION_DIGITS),
      DECIMAL
    );

    const fileTypeIsValid = PDF_TYPE.includes(file.type);
    if (!fileTypeIsValid) {
      this.fileErrorMessage = [{
        severity: 'error', detail: FileErrorMessages.INVALID_FILE_FORMAT
      }];
      this.paymentTermsModel.pdfUrl = [];
      this.paymentTermsModel.files = [];

      return false;
    }

    if (filesize > FIVE_MEGABYTES) {
      this.fileErrorMessage = [{
        severity: 'error', detail: FileErrorMessages.IMAGE_SIZE_EXCEEDED
      }];
      this.paymentTermsModel.pdfUrl = [];
      this.paymentTermsModel.files = [];

      return false;
    }

    return true;
  }

  removePdf(index?: number){
    if(index !== undefined){
      this.paymentTermsModel.pdfUrl.splice(index, 1);
      this.paymentTermsModel.files.splice(index, 1);
    } else {
      this.paymentTermsModel.pdfUrl = [];
      this.paymentTermsModel.files = [];
    }
    this.commerceService.paymentTermsModel = this.paymentTermsModel;
    this.paymentTermsNotValid.emit(this.paymentTermsModel.pdfUrl.length === 0
      || !this.paymentTermsModel.selectedFrequency
      || !this.paymentTermsModel.selectedPeriod
      || this.paymentTermsModel.driverConsent === undefined);
  }

  frequencyChanged(){
    this.commerceService.paymentTermsModel = this.paymentTermsModel;
    this.paymentTermsNotValid.emit(this.paymentTermsModel.pdfUrl.length === 0
      || !this.paymentTermsModel.selectedFrequency
      || !this.paymentTermsModel.selectedPeriod
      || this.paymentTermsModel.driverConsent === undefined);
  }

  periodChanged(){
    this.commerceService.paymentTermsModel = this.paymentTermsModel;
    this.paymentTermsNotValid.emit(this.paymentTermsModel.pdfUrl.length === 0
      || !this.paymentTermsModel.selectedFrequency
      || !this.paymentTermsModel.selectedPeriod
      || this.paymentTermsModel.driverConsent === undefined);
  }

  consentChanged(){
    this.commerceService.paymentTermsModel = this.paymentTermsModel;
    this.paymentTermsNotValid.emit(this.paymentTermsModel.pdfUrl.length === 0
      || !this.paymentTermsModel.selectedFrequency
      || !this.paymentTermsModel.selectedPeriod
      || this.paymentTermsModel.driverConsent === undefined);
  }
}
